module.exports = __webpack_public_path__ + "assets/img/16_1815.29da8570.jpg";